<template>
    <div class="videoPatch">
        <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
            <el-container>
              <div @click="rowClick()" class="videoPatchMain">
                <img :src="data.imgUrl" :alt="data.imgAlt">
              </div>
            </el-container>
        </div>
        <!--视频弹窗-->
        <video-dialog  ref="video"/>
        <!--图片弹窗-->
        <pic-dialog ref="pic"/>
    </div>
</template>
<script>
import VideoDialog from '@/components/common/components/videoDialog'
import PicDialog from '@/components/common/components/picDialog'
export default {
  components: {
    VideoDialog,
    PicDialog
  },
  props: {
    val: {}
  },
    data(){
        return{
            data: {}
        }
    },
  created() {
    this.data = this.val;
  },
  methods: {
    rowClick() {
      if(Number(this.data.type) === 0) {
        this.$router.push({
          name: 'ARTICLEDETAIL',
          query: {id: this.data.id}
        });
      } else if(Number(this.data.type) === 1) {
        this.$refs.pic.open(this.data);
      } else if(Number(this.data.type) === 2) {
        this.$refs.video.open(this.data);
      }
    }
    },
    watch: {
      val(val) {
        this.data = this.val;
      }
    }
}
</script>
<style lang="less" scoped>
.videoPatch{
    .videoPatchMain{

      width: 100%;
      // height: 540px;
      img{
        width: 100%;
        height: 100%;
      }

    }


    @media (min-width: 768px) and (max-width: 1024px) {

    }
    @media (min-width: 1024px) and (max-width: 1200px) {

    }
    @media only screen and (min-width: 1200px){

    }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch28.vue